import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

import { useInfiniteRecommendGroupByProductIdList } from '../hooks/useInfiniteRecommendGroupByProductIdList';
import { useInfiniteRecommendList } from '../hooks/useInfiniteRecommendList';

export const useInfiniteRecommendService = () => {
  const { catalog_product_id } = useCatalogProductIdParams();
  const {
    flags: { is_selected_shop },
  } = usePdpBaseInfo({ catalog_product_id });

  const defaultSubTitle = is_selected_shop ? '' : '이 상품과 연관된 상품을 추천해 드려요';

  const getRecommendList = is_selected_shop ? useInfiniteRecommendGroupByProductIdList : useInfiniteRecommendList;

  const {
    targetRef,
    title,
    subTitle,
    isAd,
    response: { isLoading, isFetchingNextPage, fetchNextPage, isError, hasNextPage },
    itemList,
    isEmpty,
    selectedDrLogMap,
  } = getRecommendList();

  const handleEndReached = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  return {
    infiniteRecommend: {
      title: title,
      subTitle: subTitle ?? defaultSubTitle,
      list: itemList,
      isFetchingNextPage,
      hasNextPage,
      isLoading,
      isError,
      isAd,
      isEmpty,
      handleEndReached,
      totalCount: Math.ceil((itemList.length ?? 0) / 2),
    },
    selectedDrLogMap,
    originalProductId: catalog_product_id,
    ref: targetRef,
  };
};
